<template>
    <UButton v-bind="$attrs" :to="to" :block="block" class="cursor-pointer px-8 mt-4 font-bold py-3 transition-all border border-red-200 bg-red-100 text-red-500 
           hover:brightness-110 hover:bg-red-200 hover:border-red-200
           active:brightness-110 active:bg-red-200 active:border-red-200" :ui="{ rounded: 'rounded-md' }">
        <slot />
    </UButton>
</template>

<script setup>
defineProps({
    to: {
        type: String,
        default: undefined
    },
    block: {
        type: Boolean,
        default: false
    }
})
</script>